const OVERRIDE_KEY = 'assetPermissionOverride'

export const defaultAssetPermissions = {
    canViewAssetModule: true,
    canCreateAsset: true,
    canEditAsset: true,
    canDeleteAsset: true,
    canAssignInspection: true,
    canGenerateQr: true,
    canPrintLabel: true,
    canUseScanner: true,
    canScheduleInspection: true,
    isViewOnly: false,
}

function parseBool(value, fallback = false) {
    if (value === undefined || value === null) return fallback
    if (typeof value === 'boolean') return value
    if (typeof value === 'number') return value === 1
    if (typeof value === 'string') {
        const v = value.trim().toLowerCase()
        if (['1', 'true', 'yes', 'y'].includes(v)) return true
        if (['0', 'false', 'no', 'n'].includes(v)) return false
    }
    return fallback
}

function getOverridePermissions() {
    try {
        const raw = localStorage.getItem(OVERRIDE_KEY)
        if (!raw) return null
        const parsed = JSON.parse(raw)
        return parsed && typeof parsed === 'object' ? parsed : null
    } catch {
        return null
    }
}

export function getAssetPermissions(user) {
    const roleId = Number(user?.RoleId || 0)
    const isReadOnlyUser = parseBool(user?.IsReadOnly, false)
    const isAdmin = roleId === 1

    // Baseline: allow module access but keep mutating actions tied to role.
    let base = {
        ...defaultAssetPermissions,
        canCreateAsset: isAdmin || !isReadOnlyUser,
        canEditAsset: isAdmin || !isReadOnlyUser,
        canDeleteAsset: isAdmin || !isReadOnlyUser,
        canAssignInspection: isAdmin || !isReadOnlyUser,
        canGenerateQr: true,
        canPrintLabel: true,
        canUseScanner: true,
        canScheduleInspection: isAdmin || !isReadOnlyUser,
        isViewOnly: !isAdmin && isReadOnlyUser,
    }

    const override = getOverridePermissions()
    if (override) {
        base = {
            ...base,
            ...override,
            canViewAssetModule: parseBool(
                override.canViewAssetModule,
                base.canViewAssetModule,
            ),
            canCreateAsset: parseBool(
                override.canCreateAsset,
                base.canCreateAsset,
            ),
            canEditAsset: parseBool(override.canEditAsset, base.canEditAsset),
            canDeleteAsset: parseBool(
                override.canDeleteAsset,
                base.canDeleteAsset,
            ),
            canAssignInspection: parseBool(
                override.canAssignInspection,
                base.canAssignInspection,
            ),
            canGenerateQr: parseBool(
                override.canGenerateQr,
                base.canGenerateQr,
            ),
            canPrintLabel: parseBool(
                override.canPrintLabel,
                base.canPrintLabel,
            ),
            canUseScanner: parseBool(
                override.canUseScanner,
                base.canUseScanner,
            ),
            canScheduleInspection: parseBool(
                override.canScheduleInspection,
                base.canScheduleInspection,
            ),
            isViewOnly: parseBool(override.isViewOnly, base.isViewOnly),
        }
    }

    if (base.isViewOnly) {
        base.canCreateAsset = false
        base.canEditAsset = false
        base.canDeleteAsset = false
        base.canAssignInspection = false
        base.canScheduleInspection = false
    }

    return base
}
